export const buildQueryWithParams = (url, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return queryString ? `${url}?${queryString}` : url;
};

export const makeListTags = (tagType) => (response) =>
  response?.list
    ? [
      { type: tagType, id: 'list' },
      response.list.map((item) => ({ type: tagType, id: item.id || item._id }))
    ]
    : [{ type: tagType, id: 'list' }];
